// extracted by mini-css-extract-plugin
export var bounce = "_q0-1";
export var generatingText = "_q0-6";
export var lightning = "_q0-4";
export var popup = "_q0-5";
export var progressBar = "_q0-7";
export var progressFill = "_q0-8";
export var progressShimmer = "_q0-9";
export var progressText = "_q0-a";
export var shimmer = "_q0-3";
export var uploadIcon = "_q0-0";
export var uploadingText = "_q0-2";